import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { CalendarDays, ChevronRight } from "lucide-react";

const MONTHS_SHORT = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"];

function formatShort(yyyymmdd) {
  if (!yyyymmdd) return "—";
  const [y, m, d] = yyyymmdd.split("-");
  return `${parseInt(d, 10)} ${MONTHS_SHORT[parseInt(m, 10) - 1]} ${y}`;
}

function colorFor(kegiatan) {
  const palette = ["#6366f1", "#ec4899", "#f59e0b", "#10b981", "#06b6d4", "#8b5cf6", "#ef4444", "#84cc16"];
  let h = 0;
  for (let i = 0; i < kegiatan.length; i++) h = (h * 31 + kegiatan.charCodeAt(i)) >>> 0;
  return palette[h % palette.length];
}

/**
 * KalenderDashboardWidget — compact widget showing upcoming events (30 days)
 * Props: linkTo — "/kepsek/kalender-pendidikan" | "/guru/kalender-pendidikan" | "/ortu/kalender-pendidikan"
 */
export default function KalenderDashboardWidget({ linkTo }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        // Tidak filter by tahun_ajaran agar widget bisa cover kegiatan yang spann lintas TA
        const { data } = await api.get("/kalender-pendidikan");
        const today = new Date().toISOString().slice(0, 10);
        const cutoff = new Date();
        cutoff.setDate(cutoff.getDate() + 30);
        const cutoffStr = cutoff.toISOString().slice(0, 10);
        const upcoming = (data || [])
          .filter((it) => it.tanggal_selesai >= today && it.tanggal_mulai <= cutoffStr)
          .sort((a, b) => a.tanggal_mulai.localeCompare(b.tanggal_mulai))
          .slice(0, 5);
        setItems(upcoming);
      } catch (e) { console.error(e); }
    })();
  }, []);

  return (
    <section className="pp-card p-4 sm:p-5" data-testid="dashboard-kalender-widget">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-semibold text-slate-900 flex items-center gap-1.5">
          <CalendarDays className="w-4 h-4 text-indigo-600" /> Kegiatan Mendatang (30 hari)
        </h3>
        <Link to={linkTo} className="text-xs text-indigo-600 hover:text-indigo-800 inline-flex items-center gap-0.5" data-testid="dashboard-kalender-more">
          Lihat semua <ChevronRight className="w-3 h-3" />
        </Link>
      </div>
      {items.length === 0 ? (
        <p className="text-xs text-slate-400 italic">Tidak ada kegiatan dalam 30 hari kedepan.</p>
      ) : (
        <ul className="space-y-1.5">
          {items.map((it) => (
            <li key={it.id} className="flex items-center gap-2.5 py-1" data-testid={`dashboard-kp-${it.id}`}>
              <span className="w-2 h-2 rounded-full shrink-0" style={{ backgroundColor: colorFor(it.kegiatan) }} />
              <span className="text-sm font-medium text-slate-800 flex-1 truncate">{it.kegiatan}</span>
              <span className="text-[11px] text-slate-500 shrink-0 font-mono">
                {it.tanggal_mulai === it.tanggal_selesai
                  ? formatShort(it.tanggal_mulai)
                  : `${formatShort(it.tanggal_mulai)}–${formatShort(it.tanggal_selesai).split(" ").slice(0, 2).join(" ")}`}
              </span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
